<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonOutline"
              size="small"
              icon="el-icon-plus"
              v-check-role
              @click="$emit('go-create')"
            >
              新增自动布局
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid filterGrid--two">
          <div class="filterItem">
            <span class="searchText">配置名称</span>
            <el-input
              class="filterControl"
              placeholder="请输入配置名称"
              prefix-icon="el-icon-search"
              :value="title"
              size="small"
              clearable
              @input="$emit('update:title', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">语言</span>
            <el-input
              class="filterControl"
              placeholder="请输入语言"
              prefix-icon="el-icon-search"
              :value="language"
              size="small"
              clearable
              @input="$emit('update:language', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">设备型号</span>
            <el-input
              class="filterControl"
              placeholder="请输入设备型号"
              prefix-icon="el-icon-search"
              :value="device"
              size="small"
              clearable
              @input="$emit('update:device', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">配置状态</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="status"
              placeholder="全部状态"
              size="small"
              clearable
              @change="$emit('update:status', $event)"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoLayoutListFilterPanel',
  props: {
    title: { type: String, default: '' },
    language: { type: String, default: '' },
    device: { type: String, default: '' },
    status: { type: [String, Number], default: '' },
    statusOptions: { type: Array, default: () => [] },
    activeFilterCount: { type: Number, default: 0 },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';
@import '../../resourceManage/genericResourceManage/linkListFilterPanel.css';
</style>